export default "<ion-app>\r\n    <app-menu></app-menu>\r\n    <ion-router-outlet id=\"main-content\"></ion-router-outlet>\r\n</ion-app>\r\n"